import { defineMessages } from "react-intl"

export const formMessages = defineMessages({
	cancel: {
		defaultMessage: "Cancel",
		id: "form.cancel",
	},
	close: {
		defaultMessage: "Close",
		id: "form.close",
	},
	deselectAll: {
		defaultMessage: "Deselect all",
		id: "select.deselectAll",
	},
	errorGeneral: {
		defaultMessage: "An error occurred",
		id: "form.error.general",
	},
	invalid: {
		defaultMessage: "The entered value is not valid",
		id: "form.error.invalid",
	},
	max: {
		defaultMessage: "The maximum value is {max}",
		id: "form.error.max",
	},
	maxLength: {
		defaultMessage: "Must consist of {value} characters at most",
		id: "form.error.maxLength",
	},
	min: {
		defaultMessage: "The minimum value is {min}",
		id: "form.error.min",
	},
	minLength: {
		defaultMessage: "Must consist of at least {value} characters",
		id: "form.error.minLength",
	},
	optional: {
		defaultMessage: "Optional",
		id: "form.optional",
	},
	required: {
		defaultMessage: "This field is required",
		id: "form.error.required",
	},
	save: {
		defaultMessage: "Save",
		id: "form.save",
	},
	selectAll: {
		defaultMessage: "Select all",
		id: "select.selectAll",
	},
})
